export default __webpack_public_path__ + "static/media/mic-mute-white.70538711.svg";